export default __webpack_public_path__ + "static/media/Inter-SemiBoldItalic.80d799be.woff";